import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '@massilia/ui';
import { useEffect, useState } from 'react';
let popoverZIndexCounter = 1000;
export function FieldError({ className, asPopover, asString, errors }) {
    const [zIndex, setZIndex] = useState(undefined);
    useEffect(() => {
        if (asPopover && errors.length > 0) {
            // Assign a decreasing z-index to ensure first mounted popovers appear on top
            const currentZIndex = popoverZIndexCounter--;
            setZIndex(currentZIndex);
        }
    }, [asPopover, errors.length]);
    if (asPopover) {
        return (errors.length > 0 && (_jsx("div", { className: cn("to-destructive absolute bottom-0 left-6 z-30 max-w-full translate-y-full rounded-sm bg-linear-to-br from-red-400 shadow-lg [&::before]:absolute [&::before]:-top-2 [&::before]:left-1/2 [&::before]:h-0 [&::before]:w-0 [&::before]:-translate-x-1/2 [&::before]:border-r-8 [&::before]:border-b-8 [&::before]:border-l-8 [&::before]:border-r-transparent [&::before]:border-b-red-400 [&::before]:border-l-transparent [&::before]:content-['']", {
                hidden: !errors.length,
            }), style: { zIndex }, children: _jsx("p", { className: "px-2 py-1.5 text-center text-xs text-wrap text-white", role: "alert", children: asString ? errors.map((error) => error).join(', ') : errors.at(0)?.message }) })));
    }
    return errors.length > 0 ? (_jsx("em", { className: cn('text-destructive text-sm', className), role: "alert", children: asString ? errors.map((error) => error).join(', ') : errors.at(0)?.message })) : null;
}
